"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultManagement = void 0;
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.defaultManagement = Joi.object({
    approvedDate: Joi.date()
        .less(utils_1.getCurrentDate()) // Can't be today or future date
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Approved Date'),
    })
        .optional()
        .when('toolApplied', {
        is: true,
        then: Joi.required(),
    }),
    toolApplied: Joi.boolean(),
    toolDetail: Joi.string()
        .min(1)
        .max(1000)
        .optional()
        .when('toolApplied', { is: true, then: Joi.required() }),
});
exports.default = { defaultManagement: exports.defaultManagement };
